function Hero() {
  return (
    <div class="hero-container" id="home">
      <div class="hero-intro">
        <h1>I'm Kyle Radick,</h1>
        <h5 class="anim-typewriter">&#123;Full Stack Developer&#125;</h5>
      </div>
      <div class="hero-portrait">
        <img src="linkedin.jpg" alt="Portrait" class="hero-portrait-image" />
      </div>
    </div>
  );
}

export default Hero;
